// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"styles_pageWrapper__4g74w","mainWrapper":"styles_mainWrapper__39_4P","pageContent":"styles_pageContent__MdTwM","coverPage":"styles_coverPage__GQsZU"};